//Removes protected strings from route path (for React Router Compatibility)
export const transformPath = (path: string) => path.replace(/[^+\w]/gm, ".");
